<script setup lang="ts">
import { useAuthStore } from '~/stores/use-auth-store';

type BtnVariant = 'flat' | 'text' | 'elevated' | 'tonal' | 'outlined' | 'plain';

const props = withDefaults(
  defineProps<{
    label?: string;
    color?: string;
    variant?: BtnVariant;
    size?: string | undefined;
    block?: boolean;
    prependIcon?: string;
  }>(),
  {
    label: 'Submit an event',
    color: 'primary',
    variant: 'tonal',
    size: undefined,
    block: false,
    prependIcon: 'mdi-plus-box',
  },
);

const authStore = useAuthStore();

// Signed-in users go straight to the funnel; anonymous visitors are routed
// through login and returned to the funnel afterwards. SSR always renders the
// anonymous branch (no session server-side) and flips reactively once
// auth.client.ts hydrates — the same mechanism the discover detail link uses.
const SUBMIT_PATH = '/discover/submit';

const target = computed(() =>
  authStore.isAuthenticated
    ? SUBMIT_PATH
    : `/login?redirect_to=${encodeURIComponent(SUBMIT_PATH)}`,
);
</script>

<template>
  <v-btn
    :to="target"
    :color="props.color"
    :variant="props.variant"
    :size="props.size"
    :block="props.block"
    :prepend-icon="props.prependIcon"
  >
    {{ props.label }}
  </v-btn>
</template>
